import React from 'react';
import { motion } from 'framer-motion';
export function WhatYouGetSection() {
  const items = [{
    emoji: '📌',
    text: 'Guía paso a paso — qué hacer, en qué orden y por qué funciona'
  }, {
    emoji: '📌',
    text: 'Plan de 7 días — una semana completa para ver los primeros cambios reales'
  }, {
    emoji: '📌',
    text: 'Plan de 30 días — para consolidar los resultados y mantenerlos'
  }, {
    emoji: '📌',
    text: 'Recetas simples — fáciles de preparar con ingredientes que ya tenés en casa'
  }, {
    emoji: '📌',
    text: 'Tips prácticos — pequeños cambios diarios con gran impacto en tu digestión'
  }];
  return <section className="w-full bg-white py-16 px-4 md:px-8" data-id="element-240">
      <div className="max-w-3xl mx-auto" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        y: 25
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-242">
          <p className="text-accent text-sm uppercase tracking-wider mb-3" data-id="element-243">
            📋 Qué incluye
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif text-text-dark" data-id="element-244">
            Todo lo que necesitás para empezar desde hoy:
          </h2>
        </motion.div>

        <div className="space-y-3 mb-8" data-id="element-245">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.07
        }} className="flex items-start gap-3 bg-bg-soft p-5 rounded-xl border border-secondary-light/20" data-id="element-246">
              <span className="text-lg flex-shrink-0" data-id="element-247">{item.emoji}</span>
              <span className="text-primary-mid text-sm" data-id="element-248">{item.text}</span>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-sm font-semibold text-accent" data-id="element-249">
          👉 Todo pensado para que lo puedas aplicar aunque tengas poco tiempo
        </motion.p>
      </div>
    </section>;
}